import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-md top-0' : 'bg-transparent top-10'
      }`}
    >
      <div className="px-6 md:px-12 py-4 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="flex items-center gap-3 cursor-pointer"
          aria-label="天神屋 トップへ戻る"
        >
          <img
            src="https://static.readdy.ai/image/832753d55565bf6aa0b01904105ef45d/602572ef5c34434494d72ca386f68265.jpeg"
            alt="天神屋 買取専門店 ロゴ — 福岡・九州の出張買取"
            title="天神屋｜買取専門店 福岡・九州全域対応"
            className="w-12 h-12 rounded-full object-cover object-top"
          />
          <div className="flex flex-col leading-tight">
            <span className={`text-xs font-medium tracking-widest transition-colors duration-300 ${scrolled ? 'text-stone-500' : 'text-white/70'}`}>
              買取専門店
            </span>
            <span className={`text-xl font-bold tracking-wider transition-colors duration-300 ${scrolled ? 'text-stone-900' : 'text-white'}`}>
              天神屋
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {[
            { label: '取扱ジャンル', id: 'genres' },
            { label: '出張買取', id: 'service' },
            { label: '対応地域', id: 'regions' },
            { label: 'よくある質問', id: 'faq' },
            { label: '会社情報', id: 'company' },
          ].map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => scrollTo(e, item.id)}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-stone-700 hover:text-amber-700' : 'text-white/90 hover:text-amber-300'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="https://lin.ee/OGQq9z6"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 flex items-center justify-center rounded-full text-white text-lg hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
            style={{ backgroundColor: '#06C755' }}
          >
            <i className="ri-line-line" />
          </a>
          <a
            href="#contact"
            onClick={(e) => scrollTo(e, 'contact')}
            className="px-6 py-2.5 rounded-full text-sm font-semibold bg-amber-600 text-white hover:bg-amber-700 transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            無料査定を申し込む
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex flex-col justify-center gap-1.5 cursor-pointer ${scrolled ? 'text-stone-900' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニューを開く"
        >
          <span className={`block h-0.5 bg-current transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block h-0.5 bg-current transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block h-0.5 bg-current transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden bg-white/98 backdrop-blur-md overflow-hidden transition-all duration-300 ${menuOpen ? 'max-h-80' : 'max-h-0'}`}>
        <div className="px-6 py-4 flex flex-col gap-4">
          {[
            { label: '取扱ジャンル', id: 'genres' },
            { label: '出張買取サービス', id: 'service' },
            { label: '対応地域', id: 'regions' },
            { label: 'よくある質問', id: 'faq' },
            { label: '会社情報', id: 'company' },
          ].map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => scrollTo(e, item.id)}
              className="text-stone-700 text-sm font-medium text-left cursor-pointer whitespace-nowrap py-1"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => scrollTo(e, 'contact')}
            className="px-6 py-3 rounded-full text-sm font-semibold bg-amber-600 text-white hover:bg-amber-700 cursor-pointer whitespace-nowrap text-center"
          >
            無料査定を申し込む
          </a>
        </div>
      </div>
    </nav>
  );
}
